'use strict';

/**
 * Directive: center-vertically
 *
 * Centers an element vertically with regard
 * to the Anthro header. If centering would
 * cause the element to disappear behind the
 * header, the element will be placed directly
 * below the header.
 */
module.exports = function(
    $window
) {
    return {
        link: function(scope, element, attrs) {
            var halfWindow = Math.floor($window.innerHeight / 2);

            scope.$watch(function() {
                var header = angular.element('.header-content');
                var headerHeight = header.length ? header[0].clientHeight : 0;
                var height = Math.round(element[0].clientHeight / 2);
                var targetTop = halfWindow - headerHeight;

                height = height > targetTop ? targetTop : height;

                element
                    .css('top', '50%')
                    .css('margin-top', -height + 'px');
            });
        }
    };
};
